import Phaser from 'phaser';
import { GAME_CONFIG } from '../config';
import { ACCESSORIES } from '../data/accessories';
import { stageProgress } from '../state/StageProgress';
import { COLORS } from '../theme';
import { setLetterboxColor } from '../utils/letterbox';

export class PreloadScene extends Phaser.Scene {
  constructor() {
    super('PreloadScene');
  }

  preload() {
    const { STAGE_W, STAGE_H } = GAME_CONFIG;
    setLetterboxColor(COLORS.ink);
    const barWidth = 480;
    const barHeight = 14;
    const cx = STAGE_W / 2;
    const cy = STAGE_H / 2;

    const barBg = this.add.rectangle(cx, cy, barWidth, barHeight, 0x222730).setOrigin(0.5);
    const barFg = this.add
      .rectangle(cx - barWidth / 2, cy, 1, barHeight, 0x9be7ff)
      .setOrigin(0, 0.5);
    const label = this.add
      .text(cx, cy - 30, 'Loading…', {
        fontFamily: 'sans-serif',
        fontSize: '20px',
        color: '#ffffff',
      })
      .setOrigin(0.5);

    this.load.on('progress', (value: number) => {
      barFg.width = Math.max(1, value * barWidth);
    });
    this.load.on('complete', () => {
      barBg.destroy();
      barFg.destroy();
      label.destroy();
    });

    // Character base
    this.load.image('body', 'assets/character/body.png');
    this.load.image('head_main', 'assets/character/head_main.png');
    this.load.image('head_eyeclosed', 'assets/character/head_eyeclosed.png');
    this.load.image('head_sad', 'assets/character/head_sad.png');

    // All accessory heads + icons (Phase 3 enables full set)
    for (const acc of Object.values(ACCESSORIES)) {
      this.load.image(acc.headKey, `assets/character/${acc.headKey}.png`);
      this.load.image(acc.accIconKey, `assets/accessories/${acc.accIconKey}.png`);
    }
  }

  create() {
    stageProgress.load();
    // Wait briefly for Google Fonts to be ready so initial Text renders use Fredoka, not fallback.
    const goNext = () => this.scene.start('HomeScene');
    const fontsApi = (document as unknown as { fonts?: { ready: Promise<unknown> } }).fonts;
    if (fontsApi?.ready) {
      fontsApi.ready.then(goNext);
      // Fallback if fonts.ready never resolves (e.g. offline).
      this.time.delayedCall(1500, goNext);
    } else {
      this.time.delayedCall(300, goNext);
    }
  }
}
